import { Lesson } from "@jelly/lesson";

import principle01 from "./layouts/principle-01/principle";
import principle02 from "./layouts/principle-02/principle";
import principle03 from "./layouts/principle-03/principle";
import task01 from "./layouts/task-01/task";

const lesson: Lesson = {
  id: "8fa3d8d1-4a0f-4453-9b2f-367e65e227c2",
  publicId: "20",
  name: "Modes in a cavity",
  difficulty: 3,
  contentTypes: { audio: false, interactive: true, video: false },
  body: [principle01, principle02, principle03, task01],
};

export default lesson;
